import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Cookie, Upload, Trash2, CheckCircle2 } from "lucide-react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { useLang } from "../../context/LangContext";
import { Button } from "../../components/ui/button";

export default function CookiesSettings() {
  const { t, lang } = useLang();
  const [st, setSt] = useState(null);
  const input = useRef(null);
  useEffect(() => { api.get("/dub/cookies").then((r) => setSt(r.data)).catch(() => {}); }, []);
  const err = (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail));

  const upload = async (file) => {
    if (!file) return;
    try { setSt((await api.put("/dub/cookies", { content: await file.text() })).data); toast.success(t("Cookies guardados", "Cookies saved")); }
    catch (e) { err(e); } finally { if (input.current) input.current.value = ""; }
  };
  const remove = async () => { try { setSt((await api.delete("/dub/cookies")).data); toast.success(t("Cookies removidos", "Cookies removed")); } catch (e) { err(e); } };

  return (
    <div className="rounded-2xl border border-white/10 bg-card p-6 space-y-3" data-testid="cookies-settings">
      <h3 className="font-heading font-bold flex items-center gap-2"><Cookie className="h-4 w-4 text-primary" />{t("Cookies para importar por URL (YouTube, Vimeo…)", "Cookies for URL import (YouTube, Vimeo…)")}</h3>
      <ol className="list-decimal pl-5 text-xs text-muted-foreground space-y-1">
        <li>{t("No Chrome ou Firefox, inicie sessão em youtube.com (de preferência com uma conta secundária).", "In Chrome or Firefox, sign in to youtube.com (ideally with a secondary account).")}</li>
        <li>{t('Instale a extensão "Get cookies.txt LOCALLY" e exporte os cookies dessa página (formato Netscape).', 'Install the "Get cookies.txt LOCALLY" extension and export that page\'s cookies (Netscape format).')}</li>
        <li>{t("Carregue aqui o ficheiro .txt. Os cookies expiram: se as importações voltarem a falhar, exporte e carregue de novo.", "Upload the .txt file here. Cookies expire: if imports fail again, export and upload a fresh file.")}</li>
      </ol>
      {st?.configured ? (
        <p className="text-sm flex flex-wrap items-center gap-2" data-testid="cookies-status">
          <CheckCircle2 className="h-4 w-4 text-emerald-400" />
          {t("Configurados", "Configured")} · {new Date(st.updated_at).toLocaleString(lang === "pt" ? "pt-PT" : "en-GB")}
          <span className="text-xs text-muted-foreground break-all">{st.domains.join(", ")}</span>
        </p>
      ) : <p className="text-sm text-muted-foreground" data-testid="cookies-status">{t("Sem cookies carregados.", "No cookies uploaded.")}</p>}
      <input ref={input} type="file" accept=".txt,text/plain" hidden data-testid="cookies-file-input" onChange={(e) => upload(e.target.files?.[0])} />
      <div className="flex gap-2">
        <Button data-testid="cookies-upload-btn" size="sm" className="gap-1.5" onClick={() => input.current?.click()}><Upload className="h-4 w-4" />{st?.configured ? t("Substituir ficheiro", "Replace file") : t("Carregar cookies.txt", "Upload cookies.txt")}</Button>
        {st?.configured && <Button data-testid="cookies-remove-btn" size="sm" variant="ghost" className="gap-1.5 text-destructive" onClick={remove}><Trash2 className="h-4 w-4" />{t("Remover", "Remove")}</Button>}
      </div>
    </div>
  );
}
